import { useTranslation } from 'react-i18next';

import { SettingsList } from '@/components/settings/SettingsList';

/**
 * Impostazioni — l'elenco delle sotto-schermate, più il logout.
 *
 * L'elenco vero sta in `SettingsList`, condiviso con la tasca Impostazioni
 * dello Zaino: le due superfici mostrano le stesse voci, e devono restare le
 * stesse anche fra sei mesi. Qui resta solo il titolo, che è l'unica cosa che
 * cambia fra i due posti.
 */
export function SettingsHome() {
  const { t } = useTranslation('general');

  return (
    <div className="flex flex-col gap-6 px-4 pb-6 pt-5">
      <header>
        <h1 className="text-2xl font-bold text-fg">
          {t('settings', { defaultValue: 'Settings' })}
        </h1>
      </header>

      <SettingsList />
    </div>
  );
}
